import { fetchAuthSession, getCurrentUser, fetchUserAttributes, updateUserAttributes } from 'aws-amplify/auth';
import { jwtDecode } from 'jwt-decode';
import { fetchCognitoUserInfo, pickNameFromUserInfo } from '../../../utils/cognitoUserInfo';

export async function getIdTokenClaims() {
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString() || null;
    let claims = {};
    try {
      if (idToken) claims = jwtDecode(idToken) || {};
    } catch (e) {
      claims = {};
    }
    return { idToken, claims };
  } catch (e) {
    return { idToken: null, claims: {} };
  }
}

export function buildUserPayload({ user, claims }) {
  return {
    cognitoSub: claims?.sub,
    email: claims?.email,
    name: claims?.name || claims?.nickname || claims?.profile_nickname || claims?.preferred_username,
    phone: claims?.phone_number,
    userName: user?.username || claims?.['cognito:username'] || claims?.username,
    eventTime: new Date().toISOString(),
  };
}

// Photo 페이지에서 쓰는 "로그인 유저 + attributes + 표시명" 로딩을 캡슐화
export async function loadPhotoUserProfile() {
  const currentUser = await getCurrentUser();

  let attributes = {};
  try {
    attributes = await fetchUserAttributes();
  } catch (e) {
    // ignore
  }

  let fallbackName;
  if (!attributes || Object.keys(attributes).length === 0) {
    const { claims } = await getIdTokenClaims();
    if (claims && (claims.name || claims.nickname || claims.profile_nickname || claims.preferred_username)) {
      fallbackName = claims.name || claims.nickname || claims.profile_nickname || claims.preferred_username;
    }
    attributes = { ...(attributes || {}), ...(claims || {}) };
  }

  // name이 비어있으면 (특히 Kakao) nickname 계열 claim로 Cognito user attribute(name)를 1회 보정 저장
  try {
    let candidate =
      attributes?.name ||
      attributes?.nickname ||
      attributes?.profile_nickname ||
      attributes?.preferred_username ||
      fallbackName ||
      null;

    if (!candidate) {
      try {
        const session = await fetchAuthSession();
        const accessToken = session.tokens?.accessToken?.toString();
        const userInfo = await fetchCognitoUserInfo(accessToken);
        candidate = pickNameFromUserInfo(userInfo) || candidate;
        if (candidate) attributes = { ...(attributes || {}), nickname: String(candidate) };
      } catch (e) {
        // ignore
      }
    }
    if (!attributes?.name && candidate) {
      const key = `photo_name_sync_done:${currentUser?.userId || currentUser?.username || 'user'}`;
      const done = sessionStorage.getItem(key);
      if (!done) {
        await updateUserAttributes({ userAttributes: { name: String(candidate) } });
        sessionStorage.setItem(key, '1');
        attributes = { ...(attributes || {}), name: String(candidate) };
      }
    }
  } catch (e) {
    // ignore
  }

  const displayName =
    attributes.name ||
    attributes.nickname ||
    attributes.profile_nickname ||
    attributes.preferred_username ||
    attributes.email ||
    fallbackName ||
    attributes['cognito:username'] ||
    '사용자';

  return {
    user: { ...currentUser, attributes, fallbackName },
    displayName,
  };
}


